import { NULL } from 'constants/index';

export const updateContentApprovalsResponse = () => ({
  updateContentApprovals: NULL,
});
